// extracted by mini-css-extract-plugin
export default {"input":"sport_input__r8kzT","teamNames":"sport_teamNames__XGKzb","name":"sport_name__vlp4a"};